import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PeoplePage } from '../../features/people/people-page.tsx';
import { parsePeopleSearch, type PeopleSearch } from '../../features/people/search.ts';
import { guardSection } from '../../shell/guard.ts';

// People and weekly load (T31). The chosen person is a URL search param (constitution §5.6).
export const Route = createFileRoute('/_authed/people')({
  beforeLoad: guardSection('/people'),
  validateSearch: (raw: Record<string, unknown>): PeopleSearch => parsePeopleSearch(raw),
  component: PeopleRoute,
});

function PeopleRoute(): React.JSX.Element {
  const { person } = Route.useSearch();
  const navigate = useNavigate({ from: '/people' });
  return (
    <PeoplePage person={person} onPerson={(id) => void navigate({ search: { person: id } })} />
  );
}
